export const CAMPAIGNS_TEXT_CONTENT = {
    NO_LOCATIONS: 'No locations found'
};

export const TOAST_TIMEOUTS = {
    SHORT: 2500,
    LONG: 5000,
    VERY_LONG: 10000,
  };
  
  export const UPDATE_FILTER_OPTIONS_ACTIONS = {
    METRIC: 'METRIC',
    TEST_LOCATIONS: 'TEST_LOCATIONS',
    CONTROL_LOCATIONS: 'CONTROL_LOCATIONS',
    TEST_PERIOD: 'TEST_PERIOD',
    CONTROL_PERIOD: 'CONTROL_PERIOD',
    TAXONOMIES: 'TAXONOMIES',
    LINE_TAXONOMIES: 'LINE_TAXONOMIES',
    BREAKDOWN: 'BREAKDOWN',
    NAME: 'NAME',
  };
  
  export const REDUCER_ACTIONS = {
    SET_FILTER_OPTIONS: 'SET_FILTER_OPTIONS',
    SET_DATA: 'SET_DATA',
    CLEAR_DATA: 'CLEAR_DATA',
    SET_DATA_UPLIFT: 'SET_DATA_UPLIFT',
    SET_PREV_FETCHED_FILTER_OPTIONS: 'SET_PREV_FETCHED_FILTER_OPTIONS',
    SET_SHOULD_FETCH_DATA: 'SET_SHOULD_FETCH_DATA',
    SET_ENABLED_LOCATIONS: 'SET_ENABLED_LOCATIONS',
    SET_TAXONOMY_LIST: 'SET_TAXONOMY_LIST',
    SET_CTX: 'SET_CTX',
    SET_TAXONOMY_KEY_STRINGS: 'SET_TAXONOMY_KEY_STRINGS',
    SET_LINE_TAXONOMY_LIST: 'SET_LINE_TAXONOMY_LIST',
    SET_LINE_TAXONOMY_KEY_STRINGS: 'SET_LINE_TAXONOMY_KEY_STRINGS',
    SET_IS_QUERY_SUBSET: 'SET_IS_QUERY_SUBSET',
    SET_SELECTED_DATE: 'SET_SELECTED_DATE',
    SET_DATA_TEST_TEST: 'SET_DATA_TEST_TEST',
    SET_DATA_TEST_CONTROL: 'SET_DATA_TEST_CONTROL',
    SET_DATA_CONTROL_TEST: 'SET_DATA_CONTROL_TEST',
    SET_DATA_CONTROL_CONTROL: 'SET_DATA_CONTROL_CONTROL',
  };

  export const ERROR_MESSAGES = {
    NO_METRIC: 'No metric selected. Please select a metric to measure for the campaign.',
    NO_TEST_LOCATIONS: 'No test locations selected. Please select at least one test location for the campaign.',
    NO_TEST_PERIOD: 'No test period selected. Please select a test period for the campaign.',
    NO_TAXONOMIES_SELECTED: 'No area taxonomies selected. Please select at least one area taxonomy for the campaign.',
    NO_CONTROL: 'No control selected. Please select a control period, or at least one control location for the campaign.',
  };